import React, { useEffect, useState } from 'react';
import avatar from '../../../assets/images/user-avatar.png';
import moment from 'moment';
import { UpdateDepositStatusForm } from '../../../components/forms/Forms';
import ImageZoom from '../../../components/image-zoom/ImageZoom';
import { FaChevronLeft } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { PageSpinner } from '../../../components/spinner/Spinner';
import { config } from '../../../Constants';

const Deposit = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const { token } = JSON.parse(secureLocalStorage.getItem(`user-info`));
  const baseURL = config.baseURL;
  const apiURL = config.apiURL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`${baseURL}/deposits/admin/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setData(data);
      } catch (error) {}
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  const {
    userName,
    amount,
    asset,
    status,
    ref,
    image,
    address,
    createdAt,
    _id,
    email,
  } = data;

  return (
    <main className='content deposit-page'>
      <div className='title-btn'>
        <Link to='/dashboard/deposits'>
          <FaChevronLeft />
        </Link>
        <h1 className='title'>User Deposit</h1>
      </div>

      {data ? (
        <div className='blocks-cont'>
          <div className='brief-block'>
            <div className='img'>
              <img src={avatar} alt='' />
            </div>
            <h2>{userName}</h2>
            <h4>{email}</h4>
          </div>

          <div className='grid'>
            {/* transaction details */}
            <div className='block'>
              <div className='title-block'>
                <h2 className='title'>Transaction Details</h2>
              </div>
              <hr />

              <form>
                {/* amount & crypto type */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='amount'>Deposited Amount</label>
                    <input type='text' value={`$${amount}`} disabled />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='amount'>Crypto Type</label>
                    <input type='text' value={asset} disabled />
                  </div>
                </div>

                {/* address & reference  */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='amount'>Deposit Address</label>
                    <input type='text' value={address} disabled />
                  </div>
                  <div className='form-control'>
                    <label htmlFor='amount'>Transaction Ref.</label>
                    <input type='text' value={ref} disabled />
                  </div>
                </div>

                {/* transaction date  */}
                <div className='form-row'>
                  <div className='form-control'>
                    <label htmlFor='amount'>Transaction Date</label>
                    <input
                      type='text'
                      value={moment(createdAt).format(`LLL`)}
                      disabled
                    />
                  </div>
                </div>
              </form>
            </div>

            {/* transaction receipt */}
            <div className='block'>
              <div className='title-block'>
                <h2 className='title'>Transaction Receipt</h2>
              </div>
              <hr />

              <div className='img'>
                <ImageZoom
                  alt='deposit receipt'
                  height={300}
                  width={300}
                  imageSrc={`${apiURL}${image}`}
                />
              </div>
            </div>

            {/* transaction status */}
            <div className='block'>
              <div className='title-block'>
                <h2 className='title'>Transaction Status</h2>
                <h4 className='sub-title'>Update Status</h4>
              </div>
              <hr />
              <UpdateDepositStatusForm status={status} depositId={_id} />
            </div>
          </div>
        </div>
      ) : (
        <PageSpinner />
      )}
    </main>
  );
};

export default Deposit;
